import React, { useEffect, useState } from "react";
import { request } from "../../../../utils/Request";
import { withTranslation } from "react-i18next";
import { dateToUtcDate, getColors, numberFormat, POINT_DECIMAL } from "../../../../utils/Helper";
import moment from "moment/moment";
import ReactECharts from "echarts-for-react";

const RevenuePerTransportVehicle = (props: any) => {
    const { t, filters } = props;
    const [chartData, setChartData] = useState<any>();
    const [driverRevenues, setTransportVehicleRevenues] = useState<any>({
        grid: { top: 8, right: 8, bottom: 24, left: 36 },
        // title: {
        //     subtext: t('revenue per truck'),
        //     x: 'center'
        // },
        tooltip: {
            trigger: 'axis',
        },
        xAxis: {
            type: 'category',
            data: [],
        },
        yAxis: {
            type: 'value',
        },
        series: [
            {
                data: [],
                type: 'bar',
                smooth: true,
            },
        ],
    });

    const getTransportRevenue = async () => {
        try {
            const response = await request({
                url: '/suppliers/dashboards/management/revenue/per/transport/vehicles',
                params: {
                    from: (
                        filters.from
                            ? moment(filters.from).clone().tz(moment.tz.guess()).utc().format("YYYY-MM-DD 00:00:00")
                            : moment().startOf("year").startOf("day").tz(moment.tz.guess()).utc().format("YYYY-MM-DD 00:00:00")
                    ),
                    to: (
                        filters.to
                            ? moment(filters.to).clone().tz(moment.tz.guess()).utc().format("YYYY-MM-DD 23:59:59")
                            : moment().endOf("year").endOf("day").tz(moment.tz.guess()).utc().format("YYYY-MM-DD 23:59:59")
                    ),
                }
            });

            const { data } = response.data;
            setChartData(data);

            const colors = getColors();

            setTransportVehicleRevenues({
                ...driverRevenues,
                xAxis: {
                    type: "category",
                    data: data.collection.map((item: any) => item.month_name),
                    axisLabel: {
                        width: 30, //fixed number of pixels
                        overflow: 'truncate', // or 'break' to continue in a new line
                        interval: 0,
                        // interval: 0,
                        rotate: 30 //If the label names are too long you can manage this by rotating the label.
                    }
                },
                dataZoom: [
                    {
                        type: 'inside'
                    }
                ],
                grid: { containLabel: true },
                yAxis: {
                    type: "value",
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                    },
                    formatter: (params: any) => {
                        return ` <strong>${ params[0].name }</strong> <br />
                            ${ params[0].seriesName }: ${ numberFormat(params[0].value, POINT_DECIMAL, ',', '.') }
                        `;
                    },
                },
                series: [
                    {
                        data: data.collection.map((item: any) => item.total),
                        name: t('total'),
                        stack: "one",
                        type: "bar",
                        itemStyle: {
                            color: (params: any) => colors[params.dataIndex]
                        }
                    },
                ],
            });
        } catch (e) {

        }
    };

    const onClickOnBarChart = (params: any) => {
        if ( !params.data ) {
            return;
        }

        const subData = chartData.collection.find((data: any) => {
            return data.month_name === params.name;
        });

        if ( !subData ) {
            return;
        }

        const colors = getColors();

        setTransportVehicleRevenues({
            xAxis: {
                data: subData.group.map((item: any) => item.name),
                axisLabel: {
                    // inside: true,
                    width: 30, //fixed number of pixels
                    overflow: 'truncate', // or 'break' to continue in a new line
                    interval: 0,
                    rotate: 30 //If the label names are too long you can manage this by rotating the label.
                },
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: false
                },
            },
            dataGroupId: '',
            grid: { containLabel: true },
            yAxis: {
                type: "value",
            },
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    type: "shadow",
                },
                formatter: (params: any) => {
                    return ` <strong>${ params[0].axisValue }</strong> <br />
                        ${ numberFormat(params[0].data, POINT_DECIMAL, ',', '.') }
                    `;
                },
            },
            series: {
                type: 'line',
                smooth: true,
                dataGroupId: subData.client,
                data: subData.group.map((item: any) => item.total),
                universalTransition: {
                    enabled: true,
                    divideShape: 'clone'
                },
                itemStyle: {
                    color: (params: any) => colors[params.dataIndex]
                }
            },
            graphic: [
                {
                    type: 'text',
                    left: 50,
                    top: 20,
                    style: {
                        text: 'Back',
                        fontSize: 18
                    },
                    onclick: () => setTransportVehicleRevenues(driverRevenues)
                }
            ]
        });
    };

    const onEvents = {
        click: onClickOnBarChart
    };

    useEffect(() => {
        async function init() {
            await getTransportRevenue();
        }

        init();
    }, [filters]);

    return (
        <div>
            <ReactECharts
                option={ driverRevenues }
                onEvents={ onEvents }
                style={ { height: '500px' } }
            />
        </div>
    );
};

export default withTranslation()(RevenuePerTransportVehicle);
